import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

const AlertMessage = ({ message, type = "success", onClose }) => {
  if (!message) return null;

  const variants = {
    success: {
      bg: "rgba(45, 212, 191, 0.12)",
      border: "rgba(45, 212, 191, 0.4)",
      text: "#2dd4bf",
    },
    error: {
      bg: "rgba(239, 68, 68, 0.12)",
      border: "rgba(239, 68, 68, 0.4)",
      text: "#ef4444",
    },
    warning: {
      bg: "rgba(251, 191, 36, 0.12)",
      border: "rgba(251, 191, 36, 0.4)",
      text: "#fbbf24",
    },
    info: {
      bg: "rgba(59, 130, 246, 0.12)",
      border: "rgba(59, 130, 246, 0.4)",
      text: "#3b82f6",
    },
  };

  const theme = variants[type] || variants.success;

  return (
    <VuiBox
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      my={1}
      px={2}
      py={1.2}
      mb={1.5}
      borderRadius="10px"
      sx={{
        background: theme.bg,
        border: `1px solid ${theme.border}`,
      }}
    >
      <VuiTypography variant="caption" sx={{ color: theme.text }}>
        {message}
      </VuiTypography>

      {onClose && (
        <VuiButton variant="text" sx={{ minWidth: "auto", px: 0.5 }} onClick={onClose}>
          ✕
        </VuiButton>
      )}
    </VuiBox>
  );
};

export default AlertMessage;
